import { Type } from "class-transformer";
import { OrderRecipientKind } from "../common/order-recipient-kind";
import { OrderAddressDTO } from "./order-address.dto";

export class OrderRecipientDTO {
	kind: OrderRecipientKind;
	firstName: string;
	lastName: string;
	companyName: string;
	taxIdentification: string;
	phoneNumber: string;
	email: string
	@Type(() => OrderAddressDTO) public address: OrderAddressDTO | null;
}